import { c as _c } from "react/compiler-runtime";
import { ChevronRightIcon } from '@heroicons/react/24/outline';
import Image from 'next/image';
import Link from 'next/link';
import { FiDownload } from 'react-icons/fi';
import { sendAnalyticsData, trackNavigation } from '@/src/utils/analytics';
export const Frequentlyuseddocs = () => {
  const $ = _c(20);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <div className="text-center"><h3 className="m-auto w-[90%] text-[28px] font-[500] text-[#3d3e40] md:mb-0 md:w-auto md:text-[36px]">Frequently Used Documents</h3><p className="mx-auto w-[70%] text-[17px] md:mx-0 md:w-auto md:text-[18px]">For purchase orders in schools and districts.</p></div>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <div className="absolute mx-7 mt-7 w-[82%] items-center md:mt-7 md:w-[85%] lg:mt-6 xl:mt-7 xl:w-[335px]"><Image src="/images/icons/freq-used-docs/card-accessory/card-accessory-2x.png" width={1024} height={1024} alt="Card Accessory" /></div>;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <div className="w-[20%]"><Image src="/images/icons/freq-used-docs/file-folder/file-folder-2x.png" width={1024} height={1024} alt="File Folder" /></div>;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <div className="flex flex-col items-center justify-center p-4"><h3 className="text-[28px] font-[500] text-[#3d3e40] md:text-[30px] lg:text-[36px]">W9 Form</h3><p className="w-[85%] text-center text-[17px] text-[#616366] md:w-[90%] md:text-[18px]">Required by districts to set up as a vendor</p></div>;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <div className="relative mx-6 items-center justify-center md:mr-6 md:w-[370px] lg:w-[40%] xl:w-[27%]">{t1}<div className="mt-10 flex w-[320px] flex-col items-center justify-center rounded-3xl bg-[#F2F9FF] px-4 pb-12 pt-24 md:w-[360px] lg:w-[100%] xl:w-[390px]">{t2}{t3}<div><button className="mt-2 flex cursor-pointer items-center justify-center gap-x-2 self-start rounded-md border-2 border-[#318AE5] px-3 py-2 text-base font-medium text-[#318AE5]" onClick={_temp}>Download <FiDownload /></button></div></div></div>;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  let t5;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <div className="absolute mx-7 mt-7 w-[82%] items-center md:mt-7 md:w-[85%] lg:mt-6 xl:mt-7 xl:w-[335px]"><Image src="/images/icons/freq-used-docs/card-accessory/card-accessory-2x.png" width={1024} height={1024} alt="Card Accessory" /></div>;
    $[5] = t5;
  } else {
    t5 = $[5];
  }
  let t6;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = <div className="w-[20%]"><Image src="/images/icons/freq-used-docs/file-folder/file-folder-2x.png" width={1024} height={1024} alt="File Folder" /></div>;
    $[6] = t6;
  } else {
    t6 = $[6];
  }
  let t7;
  if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = <div className="flex flex-col items-center justify-center p-4"><h3 className="text-[28px] font-[500] text-[#3d3e40] md:text-[30px] lg:text-[36px]">Sole Source Letter</h3><p className="w-[85%] text-center text-[17px] text-[#616366] md:w-[90%] md:text-[18px]">Required by districts to set up as a vendor</p></div>;
    $[7] = t7;
  } else {
    t7 = $[7];
  }
  let t8;
  if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
    t8 = <div className="mb-24 mt-6 flex flex-col items-center justify-center md:mx-24 md:mt-8 lg:mx-0 lg:flex-row lg:flex-wrap">{t4}<div className="relative mx-6 items-center justify-center md:mr-6 md:w-[370px] lg:w-[40%] xl:w-[27%] ">{t5}<div className="mt-10 flex w-[320px] flex-col items-center justify-center rounded-3xl bg-[#F2F9FF] px-4 pb-12 pt-24 md:w-[360px] lg:w-[100%] xl:w-[390px]">{t6}{t7}<div><button className="mt-2 flex cursor-pointer items-center justify-center gap-x-2 self-start rounded-md border-2 border-[#318AE5] px-3 py-2 text-base font-medium text-[#318AE5]" onClick={_temp2}>Download <FiDownload /></button></div></div></div></div>;
    $[8] = t8;
  } else {
    t8 = $[8];
  }
  let t10;
  let t11;
  let t9;
  if ($[9] === Symbol.for("react.memo_cache_sentinel")) {
    t9 = <div className="flex w-[70%]"><Image src="/images/icons/freq-used-docs/adv/adv_1-2x.png" width={1024} height={1024} alt="Say goodbye to pen and paper as AbleSpace simplifies day-to-day data collection with just a click, handling the rest seamlessly." /></div>;
    t10 = <h3 className="mx-4 mt-4 text-[22px] font-[500] text-[#3d3e40] md:mt-0 md:text-[36px]">How is it different from other IEP systems I already have?</h3>;
    t11 = <p className="mx-6 text-[17px] text-[#616366] md:text-[18px]">Other IEP systems help you author IEPs and generate compliance reports. But the day to day data collection is being done on pen and paper. This is where AbleSpace comes in. You enter data with a click, and AbleSpace takes care of the rest.</p>;
    $[9] = t10;
    $[10] = t11;
    $[11] = t9;
  } else {
    t10 = $[9];
    t11 = $[10];
    t9 = $[11];
  }
  let t12;
  if ($[12] === Symbol.for("react.memo_cache_sentinel")) {
    t12 = {
      color: "#ffffff"
    };
    $[12] = t12;
  } else {
    t12 = $[12];
  }
  let t13;
  if ($[13] === Symbol.for("react.memo_cache_sentinel")) {
    t13 = <Link href="/request-quote" onClick={_temp3} style={t12} className="mr-2 mt-2 flex cursor-pointer items-center gap-x-2 self-start rounded-md border-2 border-[#318AE5] bg-[#318ae5] p-3 text-base font-medium md:py-2">Get a quote <ChevronRightIcon className="h-5 w-5" /></Link>;
    $[13] = t13;
  } else {
    t13 = $[13];
  }
  let t14;
  if ($[14] === Symbol.for("react.memo_cache_sentinel")) {
    t14 = <div className="mt-8 flex w-[100%]">{t13}<Link href="/schedule-demo" onClick={_temp4} style={{
        color: "#318AE5"
      }} className="mt-2 flex cursor-pointer items-center gap-x-2 self-start rounded-md border-2 border-[#318AE5] p-3 text-base font-medium md:py-2">Schedule a Demo</Link></div>;
    $[14] = t14;
  } else {
    t14 = $[14];
  }
  let t15;
  if ($[15] === Symbol.for("react.memo_cache_sentinel")) {
    t15 = <div className="my-14 flex flex-col items-center justify-center text-center md:mx-auto md:my-28 md:w-[80%] xl:w-[46%]">{t9}{t10}{t11}<div>{t14}<div className="mt-2 flex justify-center text-[#616366]">or<Link href="/contact-us" onClick={_temp5} style={{
            color: "#318ae5"
          }} className="mx-1 font-semibold">Contact us</Link>for more information.</div></div></div>;
    $[15] = t15;
  } else {
    t15 = $[15];
  }
  let t16;
  let t17;
  if ($[16] === Symbol.for("react.memo_cache_sentinel")) {
    t16 = <h3 className="text-[28px] font-[500] text-[#3d3e40] md:text-[36px]">Funding Sources</h3>;
    t17 = <p className="mb-8 mt-4 text-[17px] text-[#616366] md:text-[18px]">K-12 educational institutions, both at the school and district levels, have access to a range of federal and statewide opportunities to fund AbleSpace purchases</p>;
    $[16] = t16;
    $[17] = t17;
  } else {
    t16 = $[16];
    t17 = $[17];
  }
  let t18;
  if ($[18] === Symbol.for("react.memo_cache_sentinel")) {
    t18 = <div className="order-2 mt-4 w-[85%] text-center md:order-1 md:ml-6 md:mt-0 md:w-[50%] md:text-left lg:ml-0 lg:w-[38%]">{t16}{t17}<Link href="/funding-opportunities" onClick={_temp6} style={{
        color: "#318ae5"
      }} className="mb-4 cursor-pointer items-center gap-x-2 self-start rounded-md border-2 border-[#318AE5] px-5 py-3 text-base font-medium md:mt-2 md:py-2">Learn more...</Link></div>;
    $[18] = t18;
  } else {
    t18 = $[18];
  }
  let t19;
  if ($[19] === Symbol.for("react.memo_cache_sentinel")) {
    t19 = <div className="pt-20" id="freq-used-docs">{t0}{t8}{t15}<div className="mx-6 mb-20 flex flex-col items-center justify-center rounded-3xl bg-[#F2F9FF] p-8 px-0 md:m-auto md:w-[90%] md:flex-row md:gap-x-6 lg:w-[85%] lg:gap-x-32 xl:w-[75%] ">{t18}<div className="order-1 flex w-[60%] md:order-2 md:mr-6 md:w-[40%] lg:mr-0 lg:w-[33%]"><Image src="/images/icons/freq-used-docs/funding-source/funding-source-2x.png" width={1024} height={1024} alt="Funding AbleSpace purchases" /></div></div></div>;
    $[19] = t19;
  } else {
    t19 = $[19];
  }
  return t19;
};
function _temp() {
  window.open("/assets/AbleSpace-W9-2024.pdf", "_blank");
  sendAnalyticsData("DOWNLOAD_W9_FORM_BUTTON_CLICKED_FROM_FREQ_USED_DOCS");
}
function _temp2() {
  window.open("/assets/AbleSpace Sole Source.pdf", "_blank");
  sendAnalyticsData("DOWNLOAD_SOLE_SOURCE_LETTER_BUTTON_CLICKED_FROM_FREQ_USED_DOCS");
}
function _temp3() {
  return trackNavigation("request-quote", "Get a quote");
}
function _temp4() {
  return trackNavigation("schedule-demo", "Schedule a Demo");
}
function _temp5() {
  sendAnalyticsData("CONTACT_US_BUTTON_CLICKED_FROM_SCHOOLANDDISTRICT");
  trackNavigation("contact-us", "Contact us");
}
function _temp6() {
  return sendAnalyticsData("LEARN_MORE_BUTTON_CLICKED_FROM_FUNDING_SOURCES");
}